import React from 'react'
import MenuIcon from '../../assets/icons/Menu2'
import { useNavigate } from 'react-router-dom';
import Dropdown from '../inputs/dropdown';
import { useAuthContext } from '../../context';

function Navbar({ handleSidebarClick }) {
    const { removeSession, getEmail } = useAuthContext()
    function logOutAction() {
        removeSession();
        console.log('ss')
        navigate('/');
    }
    const navigate = useNavigate();
    const dropDownList = [
        {
            index: '1',
            component: <a onClick={() => logOutAction()} className='top-border'> Logout</a>,
        },
    ]
    return (
        <nav className='navbar'>
            <button onClick={handleSidebarClick} className='sidebar-toogle'>
                <MenuIcon />
            </button>
            <Dropdown title={getEmail()} list={dropDownList} />
        </nav>
    )
}

export default Navbar